const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

export function formatUptimeDuration(durationMs: number) {
  const elapsed = Math.max(durationMs, 0);

  if (elapsed >= DAY_MS) {
    const days = Math.floor(elapsed / DAY_MS);

    return `${days} ${days === 1 ? 'day' : 'days'}`;
  }

  if (elapsed >= HOUR_MS) {
    const hours = Math.floor(elapsed / HOUR_MS);
    const minutes = Math.floor((elapsed % HOUR_MS) / MINUTE_MS);

    return minutes ? `${hours}h ${minutes}m` : `${hours}h`;
  }

  return `${Math.floor(elapsed / MINUTE_MS)}m`;
}
